import React from 'react';
import queryString from 'query-string';
import { Card, Col, Row } from 'react-bootstrap';

import PageBar from '../../component/PageBar';
import { GetList, Update, Create, Delete } from './http';
import moment from 'moment';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            search: {
                page: 1,
                size: 30,
                sort: '-id',
                status: 'OPENED',
                title: '',
            },
            type: {
                NORMAL: '일반',
                FIX: '고정',
            },
            typeColor: {
                NORMAL: 'purple',
                FIX: 'yellow',
            },
            branchs: [],
            totalPages: 20,
        };

        const params = sessionStorage.getItem('notice_search');
        if (params) {
            this.state.search = JSON.parse(params);
        }

        this.reloadList(1);
    }

    reloadList = page => {
        const params = this.state.search;
        params.page = page;
        sessionStorage.setItem('notice_search', JSON.stringify(params));

        this.setState({
            search: params,
        });

        GetList(this, params, this.resultList.bind(this));
    };

    /**
     * 리스트
     */
    resultList = response => {
        this.setState({
            items: response.rows,
            totalPages: Math.ceil(response.range.total / response.range.size),
        });
    };

    /**
     * 클릭
     * @param {*} item
     */
    clickRow = item => {
        window.location = '/a/notice/edit/' + item.id;
    };

    render() {
        const { items } = this.state;
        return (
            <div>
                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                <div className="search_box_2">
                                    <input
                                        placeholder="검색어를 입력하세요."
                                        type="text"
                                        class="form-control search01"
                                        onChange={e => {
                                            const search = this.state.search;
                                            search.title = e.target.value;
                                            this.setState({ search });
                                        }}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                this.reloadList(1);
                                            }
                                        }}
                                    />
                                    <button class="btn_01 deep" onClick={e => this.reloadList(1)}>
                                        검색
                                    </button>
                                </div>
                            </div>

                            <div className="rb">
                                <button
                                    title="공지사항 생성하기"
                                    onClick={e => {
                                        window.location = '/a/notice/edit';
                                    }}
                                    className="btn_02 red"
                                >
                                    <i className="feather icon-plus" /> 등록
                                </button>
                            </div>
                        </div>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">공지사항 목록</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board list pointer">
                                        <colgroup>
                                            <col width="10%" />
                                            <col width="10%" />
                                            <col width="50%" />
                                            <col width="15%" />
                                            <col width="15%" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>타입</th>
                                                <th>제목</th>
                                                <th>게시일</th>
                                                <th>작성일</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map(x => (
                                                <tr
                                                    onClick={e => {
                                                        this.clickRow(x);
                                                    }}
                                                >
                                                    <td>{x.id}</td>
                                                    <td>
                                                        <span className={'circle01 ' + this.state.typeColor[x.type]}></span> {this.state.type[x.type]}
                                                    </td>
                                                    <td className="txtL">{x.title}</td>
                                                    <td>{moment(x.openedAt).format('YYYY-MM-DD')}</td>
                                                    <td>{moment(x.createdAt).format('YYYY-MM-DD')}</td>
                                                </tr>
                                            ))}

                                            {/* <tr
                                                onClick={e => {
                                                    this.clickRow(100);
                                                }}
                                            >
                                                <td>100</td>
                                                <td>
                                                    <span className="circle01 purple"></span> 게시
                                                </td>
                                                <td className="txtL">
                                                    <a href="javascript:;" className="tit">
                                                        [장애] [복구완료] 대시보드 통계 멈춤 현상에 대한 일시적인 일은 다 끝났습니다.
                                                    </a>
                                                </td>
                                                <td>
                                                    <span className="ellips">2020-01-01 11:11:11</span>
                                                </td>
                                                <td>
                                                    <span className="ellips">2020-01-01 11:11:11</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>100</td>
                                                <td>
                                                    <span className="circle01 purple"></span> 게시
                                                </td>
                                                <td className="txtL">
                                                    <a href="javascript:;" className="tit">
                                                        [장애] [복구완료] 대시보드 통계 멈춤 현상에 대한 일시적인 일은 다 끝났습니다.
                                                    </a>
                                                </td>

                                                <td>
                                                    <span className="ellips">2020-01-01 11:11:11</span>
                                                </td>
                                                <td>
                                                    <span className="ellips">2020-01-01 11:11:11</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>100</td>
                                                <td>
                                                    <span className="circle01 purple"></span> 게시
                                                </td>
                                                <td className="txtL">
                                                    <a href="javascript:;" className="tit">
                                                        [장애] [복구완료] 대시보드 통계 멈춤 현상에 대한 일시적인 일은 다 끝났습니다.
                                                    </a>
                                                </td>
                                                <td>
                                                    <span className="ellips">2020-01-01 11:11:11</span>
                                                </td>
                                                <td>
                                                    <span className="ellips">2020-01-01 11:11:11</span>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.page)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
